<template>
  <modal wrapperClasses="passcode">
    <div slot="body" class="modal-content">
      <div class="content">set up a unique 4-digit PIN and never miss another offer from us!</div>
    </div>
    <div slot="action" class="modal-click-action">
      <button @click="clickedRequestTempPin()" class="button submit">request a temp PIN</button>
    </div>
  </modal>
</template>

<script>
  import Modal from '../../components/shared/Modal'

  export default {
    name: 'GetStartedModal',

    components: {
      Modal
    },

    methods:{
      clickedRequestTempPin(){
        this.$emit('clickedRequestTempPin')
      }
    }
  }
</script>